import { ForawrdBackwardButton } from "../../../styled-components/PageHeaderStyles";
import LabelText from "../../../ui/LabelText";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "styled-components";
import { useSearch } from "../../../contexts/PlayerSearchContext";
import LabelNumber from "../../../styled-components/LabelNumber";
import { useLoading } from "../../../contexts/LoadingContext";
import { IValueGraph, IValueSeasonGraphChart } from "../../../types/IValueGraphChart";
import SecondaryButton from "../../../ui/SecondaryButton";
import { useState } from "react";
import { IFinancialPlayerTransfer } from "../../../types/IClubDetail";
import TransferHistory from "./TransferHistory";




const ValueGraphContainer = styled.div`
//   border: 1px solid ${({ theme }) => theme.playerDataBorder};
padding: 0px 68px 0px 68px;
`;
const HeaderContainer = styled.div`
  background: ${({ theme }) => theme.playerCardBackground};
`;
const ValueGraphFullView = styled.div`
  background: ${({ theme }) => theme.playerContentBackground};
`;

const options = ['Matches', 'Seasons'];

interface FullViewContentProps {
    teamId: string;
    onClose: () => void;
    isFullView: boolean;
    clubName : string | undefined;
    isFullview?: boolean
}

const FullViewTransferHistory: React.FC<FullViewContentProps> = ({teamId,  onClose, isFullView , clubName}) => {

  return (
    <div>
      <HeaderContainer className="header-container">
        <div className="player-name">
          <LabelText className="drawer-title expanded-market-value">Transfers & 1st team promotions</LabelText>
          <LabelNumber className="market-value-player-name">: {clubName!}</LabelNumber>
        </div>
        <div className="market-value-buttons">
        </div>
        <div className="player-name-cross">
          <ForawrdBackwardButton onClick={onClose}>
            <CloseIcon className="cta-btn-icons" />
          </ForawrdBackwardButton>
        </div>
      </HeaderContainer>
      <ValueGraphFullView className="valuegraph-fullview">
        <ValueGraphContainer className={`value-graph-container ${isFullView && "fullview-container"}`}>

        <TransferHistory 
                teamId={teamId}
                isFullView={isFullView}
                />
         
        </ValueGraphContainer>
      </ValueGraphFullView>
    </div>
  );
};

export default FullViewTransferHistory;
